import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { guestGuard } from './guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
    canActivate: [guestGuard]
  },
  {
    path: 'seleccion',
    loadComponent: () => import('./pages/seleccion/seleccion.page').then(m => m.SeleccionPage),
    canActivate: [authGuard]
  },
  {
    path: 'solicitud/:id/:aprobar',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/detalles/detalle-solicitud.page')
        .then(m => m.DetalleSolicitudPage)
  },
  {
    path: 'vuelos',
    loadComponent: () => import('./pages/vuelos/vuelos.page').then(m => m.VuelosPage),
    canActivate: [authGuard]
  },
  {
    path: 'hotel',
    loadComponent: () => import('./pages/hotel/hotel.page').then(m => m.HotelPage),
    canActivate: [authGuard]
  },
  {
    path: 'hoteles-disponibles',
    loadComponent: () => import('./pages/hoteles-disponibles/hoteles-disponibles.page').then(m => m.HotelesDisponiblesPage),
    canActivate: [authGuard]
  }
];